import { error, type Load } from '@sveltejs/kit';
import type { Page } from '@agapi/mlc-core';

import { getLocaleFromUrl } from '../../utils';
import { getPage } from '../../clients/storyblok.client';

export interface Response extends Record<string, unknown> {
  frontPageData: Page;
}

export const load: Load<{}, Response, {}, Response> = async ({ setHeaders, fetch, url, data}) => {
  /*
  setHeaders({ 'Cache-Control': 'max-age=0, s-maxage=86400' }); // Cache for 1 day

  const { language, country } = getLocaleFromUrl(url);
  const frontPageData = await getPage(fetch, { locale: language, market: country, slug: 'front-page', fetchFromRoot: true });

  if (!frontPageData) {
    throw error(404, 'Front page not found');
  }
  */

  return { frontPageData: data.frontPageData };
};
